import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import './Banner.css';

const Banner = () => {
  const [banners, setBanners] = useState([]);
  const [page, setPage] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL

  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);

  // Fetch banners data
  useEffect(() => {
    fetch('https://aprilone-178ea8362c0b.herokuapp.com/banner')
      .then((res) => res.json())
      .then((info) => setBanners(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);

  // Fetch blog post data when pageSlug changes


  return (



    <>

      {
        banners.map(b => b.pageSlug === page.pageSlug && <div className="banner_outer">
          <section className="banner-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="banner_content" data-aos="fade-down">
                    <h1 className="custom-banner">{b.bannerHeading}</h1>
                    <h3 className="text-white">{b.buttonURLTwo}</h3>
                    <p className="text-white">{b.bannerDetails}</p>
                    <div className="price-button">
                      <a className="  button-professional  " href={b.buttonURL}>{b.buttonText}</a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="banner_wrapper2">
                    <figure className="mb-0 bannerphoneback">
                      <img src={b.imageOne} alt />
                    </figure>
                    <figure className="mb-0 bannerphone-circle">
                      <img className="img-fluid" src="./assets/images/bannerphone-circle.png" alt />
                    </figure>
                  </div>
                </div>
              </div>
              <figure className="mb-0 bannersidecircle1" data-aos="fade-left">
                <img src="./assets/images/banner-sidecircle1.png" alt />
              </figure>
              <figure className="mb-0 bannersidecircle2" data-aos="fade-left">
                <img src="./assets/images/banner-sidecircle2.png" alt />
              </figure>
            </div>
          </section>
        </div>)}


    </>

  );
};

export default Banner;
